module.exports = __webpack_public_path__ + "static/calligraphy.1ba36cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calligraphy.jpg
// module id = 841
// module chunks = 232045937915672